/**
 * @prop --wf-social-media-title-color: The color of the box title, default (--mdc-theme-accent).
 * @prop --wf-social-media-title-font-weight: The font weight of the title.
 * @prop --wf-social-media-title-font-size: The font weight of the title in medium and large viewports.
 */

:host {
    box-sizing: border-box;
    display: block;
    color: var(--text-color-light, rgb(0 0 0 / 50%));
    line-height: 1.5;
    padding: 16px 0;
}


.title {
    line-height: 1.71;
    color: var(--wf-social-media-title-color, var(--mdc-theme-accent));
    font-size: var(--wf-social-media-title-font-size, 0.875rem);
    font-weight: var(--wf-social-media-title-font-weight, bold);
}

.black {
    color: #000;
}

.logos {
    margin-top: 12px;
    display: flex;
    gap: 8px;
}

@media screen and (min-width: 768px) {
    :host {
        padding: 16px 0;
    }

    .title {
        font-size: var(--wf-social-media-title-font-size-large, 1rem);
    }
}
